const isActiveSession = (sessionId) => {
  if (!window.localStorage.getItem(sessionId)) return false;

  // Get the time the session began
  const sessionTime = window.localStorage.getItem(sessionId + '.time');
  if (!sessionTime) return false;

  clearExpiredSessions();

  // If the session still exists after all expired sessions are cleared, it is still active
  if (window.localStorage.getItem(sessionId + '.time')) {
    // Update the session time
    window.localStorage.setItem(sessionId + '.time', new Date().getTime());
    return true;
  } else {
    return false;
  }
};

const createSession = (sessionId) => {
  window.localStorage.setItem(sessionId, sessionId);
  window.localStorage.setItem(sessionId + '.time', new Date().getTime());
};

const clearExpiredSessions = () => {
  Object.keys(window.localStorage).forEach((key) => {
    const value = window.localStorage.getItem(key);
    if (key.includes('.time')) {
      if (isSessionExpired(value)) {
        const sessionId = key.split('.')[0];
        localStorage.removeItem(sessionId);
        localStorage.removeItem(key);
      }
    }
  });
};

const isSessionExpired = (sessionTime) => {
  const currentTime = new Date().getTime();
  const sessionDuration = currentTime - sessionTime;
  const sessionDurationMinutes = sessionDuration / 1000 / 60;

  // Sessions expire after 30 minutes
  return sessionDurationMinutes >= 30;
};

export {
  isActiveSession,
  createSession,
};

